import { createAsyncThunk } from '@reduxjs/toolkit';
import type { SettingsNode } from '@syfo/types/adviser.types';

interface UpdateAdviserSettingsParams {
  uuid: string;
  settings: SettingsNode;
}

interface UpdateAdviserSettingsResponse {
  message: string;
}

/**
 * Update adviser settings
 */
export const updateAdviserSettingsThunk = createAsyncThunk<
  UpdateAdviserSettingsResponse,
  UpdateAdviserSettingsParams
>(
  'advisers/updateSettings',
  async ({ uuid, settings }) => {
    console.log(`[Advisers] Updating settings for adviser ${uuid}...`);

    const response = await fetch(`/api/advisers/${uuid}/settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(settings)
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Adviser not found');
      }
      if (response.status === 400) {
        const errorText = await response.text();
        throw new Error(errorText || 'Invalid settings data');
      }
      const errorText = await response.text();
      console.error(`[Advisers] Failed with status ${response.status}: ${errorText}`);
      throw new Error(`Failed to update adviser settings: ${response.status}`);
    }

    const result: UpdateAdviserSettingsResponse = await response.json();
    console.log('[Advisers] Settings updated successfully');
    
    return result;
  }
);
